import CryptoJS from 'crypto-js'
import {useState, useEffect, SetStateAction} from 'react'
import axios from 'axios'
import { HTML_Template, HTML_VerifyEmail } from './utils/email_template'
import { useNavigate } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import { authentication_error_messages, BASE_URL, error_messages } from './utils/Scripts'
import { useIsMobile } from './context/MobileContext'
import { useAuth } from './context/AuthProvider'
import VerifyInput from './account/VerifyInput'
// import { useFirebaseAuth } from './hooks/useFirebaseAuth'

const inputStyle =(width='20vw',valid=true)=> {
        return(
            {
        backgroundColor:'#fff',
        padding:'12px',
        border:`1px solid ${valid?'#c7c7c7':'#fd3939'}`,
        outline:'none',
        borderRadius:'10px',
        color:'#000',
        height:'20px',
        width:width,
            }
        )
}

const MainCreate:React.FC<{
    setStatus: React.Dispatch<SetStateAction<number>>,
    setUidMemory: React.Dispatch<SetStateAction<string>>
}>=({
    setStatus,
    setUidMemory
})=>{

    const isMobile = useIsMobile()
    const [isLoading, setIsLoading] = useState(false)
    const [validate, setValidate] = useState({email:true, repeat:true, pass:true})
    const [errorMessage, setErrorMessage] = useState('')
    const {signup} = useAuth()

    function validate_data(email:string, pass:string, repeat:string){
        let isValid = {email:false, repeat:false, pass:false}
        if(email.length>4){
            isValid.email = true
        }
        if(pass.length>4){
            isValid.pass = true
        }
        if(repeat==pass){
            isValid.repeat = true
        }
        return(isValid)
    }

    async function handleCreate(){

        const email = document.getElementById("email")! as HTMLInputElement
        const pass = document.getElementById("password")! as HTMLInputElement
        const repeat = document.getElementById("repeatpassword")! as HTMLInputElement
        const valObj:any = validate_data(email.value.toUpperCase(), pass.value, repeat.value)
        let val = true
        Object.keys(valObj).forEach((key)=>{
          if(!valObj[key]){
            val = false
          }
        })
        if(val){
            // const options = {
            //     url:BASE_URL+'accounts/create',
            //     method:'POST',
            //     headers: {
            //         'content-type': 'application/json',
            //     },
            //     data:{
            //         email: email.value.toUpperCase(),
            //         password: CryptoJS.SHA256(pass.value).toString()
            //     }
            // }
            // setIsLoading(true)
            // await axios.request(options)
            // .then((res)=>{
            //     if(res.status==200){
            //         setIsLoading(false)
            //         setStatus(1)
            //         setEmailMemory(email.value)
            //     }
            // })
            // .catch((err)=>{
            //     if(err.response.data.code){
            //         setErrorMessage(error_messages[err.response.data.code])
            //     }
            //     setIsLoading(false)
            // })
            setIsLoading(true)
            try{
                const userCredentials = await signup(email.value, pass.value)
                const options = {
                    url:BASE_URL+'accounts/create',
                    method:'POST',
                    headers: {
                        'content-type': 'application/json',
                    },
                    data:{
                        email: email.value.toUpperCase(),
                        uid: userCredentials.user.uid
                    }
                }
                await axios.request(options)
                .then(()=>{
                    setIsLoading(false)
                    setStatus(1)
                    setUidMemory(userCredentials.user.uid)
                })
            }
            catch (err:any){
                setIsLoading(false)
                setErrorMessage(authentication_error_messages[err.code] || "Erro inesperado. Tente novamente.");
            }
        } else {
            setValidate(valObj)
        }
    }


        return(
            <div style={{fontFamily:'Inter', fontWeight:'600', textAlign:'center'}}>
                <div>
                    <div style={{textAlign:'left'}}>Email</div>
                    <div>
                        <input type='text' id='email' style={inputStyle(isMobile?'60vw':undefined,validate.email?true:false)} autoComplete='off'/>
                    </div>
                </div>
                <div>
                    <div style={{textAlign:'left'}}>Senha</div>
                    <div>
                        <input type='password' id='password' style={inputStyle(isMobile?'60vw':undefined,validate.pass?true:false)} autoComplete='off'/>
                    </div>
                </div>
                <div>
                    <div style={{textAlign:'left'}}>Repetir Senha</div>
                    <div>
                        <input type='password' id='repeatpassword' style={inputStyle(isMobile?'60vw':undefined,validate.repeat?true:false)} autoComplete='off'/>
                    </div>
                </div>
                {errorMessage&&(
                    <div style={{color:'#F54927', fontSize:'12px', marginTop:'5px'}}>
                        {errorMessage}
                    </div>
                )}
                <div>
                    {!isLoading?(
                        <div style={{backgroundColor:'#000', color:'#fff', padding:isMobile?'7px 20px':'10px 30px', width:'100px', cursor:'pointer',borderRadius:'20px', marginTop:'10px', display:'inline-block'}} onClick={()=>{handleCreate()}}>
                        Criar Conta
                    </div>
                    ):(
                        <div>
                         <CircularProgress/>
                        </div>
                    )}
                    
                </div>
            </div>
        )
}

const Verify:React.FC<{
    uidMemory:string
}>=({
    uidMemory
})=>{

    const isMobile = useIsMobile()
    const navigate = useNavigate()
    const {setUser} = useAuth()

    const [codeValid, setCodeValid] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [waitSeconds, setWaitSeconds] = useState(60)

    async function handleVerify(){
        let code = ''
        for(let a=0;a<6;a++){
            let code_char = (document.getElementById('verify_char_'+String(a)) as HTMLInputElement).value
            code = code+code_char
        }
        if(code.length===6){
            const options = {
                url:BASE_URL+'accounts/verify',
                method:'POST',
                headers: {
                    'content-type': 'application/json',
                },
                data:{
                    uid: uidMemory,
                    code: code
                }
            }
            setIsLoading(true)
            await axios.request(options)
            .then((res)=>{
                setUser((prev:any)=>({...prev, verified:true, roles: res.data.roles}))
                navigate('/login')
            })
            .catch((err)=>{
                setIsLoading(false)
                setCodeValid(false)
            })
        } else {
            setCodeValid(false)
        }
    }

    async function resendCode(){
        if(waitSeconds===0){
            const options = {
                url:BASE_URL+'accounts/resend_code',
                method:'POST',
                headers: {
                    'content-type': 'application/json',
                },
                data:{
                    uid: uidMemory,
                }
            }
            await axios.request(options)
            .then(()=>{
                setWaitSeconds(60)
            })
            .catch((err)=>{
                if(err.response?.data.code==='WAIT'){
                    setWaitSeconds(err.response.data.amount)
                } else {
                    setWaitSeconds(60)
                }
            })
        } else {
            return
        }
    }

        useEffect(() => {
            if (waitSeconds <= 0) {
            return
            }

            const interval = setInterval(() => {
            setWaitSeconds((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(interval); // limpa ao desmontar
        }, [waitSeconds]);

        return(
            <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                <div style={{marginBottom:'10px'}}>
                    <VerifyInput codeValid={codeValid}/>
                </div>
                <div style={{marginBottom:'10px', maxWidth:isMobile?'80vw':'300px', fontFamily:'Inter', fontSize:'12px', textAlign:'center'}}>
                    Para verificar sua conta, copie e cole o código de 6 digitos enviado para o seu e-mail. Lembre-se de checar o Spam ou Lixo Eletrônico.
                </div>
                <div>
                {!isLoading?(
                    <div style={{backgroundColor:'#000', color:'#fff', padding:'10px 30px', cursor:'pointer', borderRadius:'20px', width:'fit-content', display:'inline-block', fontFamily:'Inter', fontWeight:'600'}} onClick={()=>{handleVerify()}}>
                        Verificar E-mail
                    </div>
                ):(
                    <div>
                        <CircularProgress/>
                    </div>
                )}
                </div>
                <div style={{marginTop:'10px', maxWidth:isMobile?'80vw':'300px', fontFamily:'Inter', fontSize:'12px', textAlign:'center', color:"#757575", cursor:waitSeconds>0?'default':'pointer'}}
                    onClick={()=>{
                        resendCode()
                    }}
                    >
                    {waitSeconds>0&&(
                    <span>
                    Não recebeu um e-mail? Envie novamente em {waitSeconds} segundos.
                    </span>
                    )||(
                        <span>
                            Reenviar código por e-mail
                        </span>
                    )}
                </div>
            </div>
        )
    }

export function CreateAccount(props:any){

    const [status, setStatus] = useState(0)
    const [uidMemory, setUidMemory] = useState('')
    const {user} = useAuth()

    useEffect(()=>{
        if(props.verifyMail){
            setUidMemory(props.verifyMail)
        } else if(user?.uid&&!user?.verified){
            setUidMemory(user.uid)
        }
    },[])

    useEffect(()=>{
        if(uidMemory){
            setStatus(1)
        }
    },[uidMemory])

    return(
        <div>
            <div style={{margin:'0 auto', backgroundColor:'#eee', borderRadius:'10px', width:'fit-content', height:'fit-content', textAlign:'left', padding:'30px'}}>
                {status==0&&(<MainCreate setStatus={setStatus} setUidMemory={setUidMemory}/>)}
                {status==1&&(<Verify uidMemory={uidMemory}/>)}
            </div>
        </div>
    )
}